// extracted by mini-css-extract-plugin
module.exports = {"error":"Select_error__fN2qQ"};